import { readGeneratedConfig } from './readGeneratedConfig.js';
import { describe, it, expect } from '@jest/globals';
import { createTestFileStructure } from '@ms-cloudpack/test-utilities';
import { dedent } from 'ts-dedent';

describe('readGeneratedConfig', () => {
  it('returns the generated file', async () => {
    const appPath = await createTestFileStructure({
      'cloudpack.config.json': { packageSettings: [{ name: 'user' }] },
      'cloudpack.generated.json': { packageSettings: [{ name: 'generated', version: '*' }] },
    });
    const result = await readGeneratedConfig(appPath);
    expect(result).toEqual({ packageSettings: [{ name: 'generated', version: '*' }] });
  });

  it('returns an empty object if the file does not exist', async () => {
    const appPath = await createTestFileStructure({
      'cloudpack.config.json': { packageSettings: [{ name: 'user' }] },
    });
    const result = await readGeneratedConfig(appPath);
    expect(result).toEqual({});
  });

  it("throws an error if generated config file can't be parsed", async () => {
    const appPath = await createTestFileStructure({
      'cloudpack.config.json': '{}',
      'cloudpack.generated.json': '{"packageSettings": }',
    });

    await expect(() => readGeneratedConfig(appPath)).rejects.toThrow(
      /^Error parsing JSON from .*?cloudpack\.generated\.json: /,
    );
  });

  it('allows trailing commas and comments in config files', async () => {
    const appPath = await createTestFileStructure({
      'cloudpack.generated.json': dedent`
          /**
           * THIS FILE IS AUTO-GENERATED.
           */
          {
            // comment
            "packageSettings": [
              {
                "match": { "name": "foo", }, // comment
                "exports": { /*comment*/ ".": "./index.js", },
              },
            ],
          }`,
    });

    const config = await readGeneratedConfig(appPath);

    expect(config).toEqual({
      packageSettings: [{ match: { name: 'foo' }, exports: { '.': './index.js' } }],
    });
  });
});
